import { useRef, useState } from 'react'

import { useIntl } from 'react-intl'

import { useOnClickOutside } from 'hooks/useOnClickOutsite'

import { ToolsShareSocial } from '../toolsShareSocial'
import { StyledMoreOption, StyledMorePopup } from './index.styled'

type Props = {
  isMobile: boolean
  shareUrl: string
  onRecalculate: () => void
  onClose: () => void
}

const HealthToolMorePopup = ({
  isMobile,
  shareUrl,
  onRecalculate,
  onClose,
}: Props) => {
  const [showShareUrls, setShowShareUrls] = useState<boolean>(false)
  const morePopupRef = useRef<HTMLDivElement | null>(null)
  const { formatMessage: f } = useIntl()

  useOnClickOutside(morePopupRef, () => {
    onClose()
  })

  return (
    <StyledMorePopup ref={morePopupRef}>
      {showShareUrls ? (
        <ToolsShareSocial
          className="share-group"
          shareUrl={shareUrl}
          isMobile={isMobile}
        />
      ) : (
        <>
          <StyledMoreOption onClick={onRecalculate}>
            <img
              src="/svg/rotate-left.svg"
              style={{ transform: 'rotateY(180deg)' }}
              alt=""
              loading="lazy"
            />
            <div>{f({ id: 'ovulationPage.recalculate' })}</div>
          </StyledMoreOption>
          <StyledMoreOption onClick={() => setShowShareUrls(true)}>
            <img src="/svg/share-article.svg" alt="" loading="lazy" />
            <div>{f({ id: 'tools.shareResultOn' })}</div>
          </StyledMoreOption>
        </>
      )}
    </StyledMorePopup>
  )
}

export { HealthToolMorePopup }
